<template>
  <div>
    <v-card class="rounded-lg" color="#41916b" elevation="0">
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
        <v-tab>Avaliação Médica - Paciente: {{ resource.name }}</v-tab>
        <v-tab-item>
          <ConsetimentoComp :donorId="resource.id" @changeTab="tab = $event" />
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-snackbar
      absolute
      background-color="white"
      color="green"
      v-model="snackbar"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      absolute
      background-color="white"
      color="red"
      v-model="snackbar_error"
    >
      {{ messageError }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "@/axios";
// import AceiteFamiliar from "./AceiteFamiliar.vue";
import ConsetimentoComp from "../validacaoDoador/Consetimento-comp.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      tab: 0,
      dialog: false,
      displayError: {
        display: false,
        message: [],
      },
      anexosForm: {
        donor_id: localStorage.getItem("donorId"),
        attachments_type_id: 1,
      },
      headers: [
        {
          text: "Descrição do Anexo",
          align: "center",
          value: "attachment_name",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      dialogDonor: false,
      donor_id: "",
      loading: true,
      options: {},
      donor: [],
      data: [],
      arquivos: [],
      status_serology: [],
      openButtons: false,
      selected: "",
      message: "",
      snackbar: false,
      snackbar_error: false,
      messageError: "",
      unity: "",
      donorID: "",
      donorName: "",
      is_donorName: "",
      is_donorSex: "",
      openModal: false,
      donorButton: true,
      formRules: [(v) => !!v || "Este campo é obrigatório"],
    };
  },

  components: {
    // AceiteFamiliar,
    ConsetimentoComp,
  },

  created() {},

  computed: {
    ...mapGetters({
      resource: "getPatientData",
      donor_id: "getDonorId",
    }),
  },

  watch: {},

  mounted() {
    this.loadTable();
  },

  methods: {
    ...mapActions([
      "changeDonorId",
      "changePCRDeathData",
      "changeCaptationData",
    ]),

    addAttachment() {
      if (this.$refs.form.validate()) {
        this.anexosForm.donor_id = this.resource.id
          ? this.resource.id
          : this.donor_id;
        let anexosData = new FormData();
        anexosData.append("donor_id", this.anexosForm.donor_id);
        anexosData.append("attachment_name", this.anexosForm.attachment_name);
        anexosData.append("attachment", this.anexosForm.attachment);
        anexosData.append(
          "attachments_type_id",
          this.anexosForm.attachments_type_id
        );
        axios
          .post(`/attachments/create`, anexosData)
          .then((response) => {
            this.loadGridData();
            this.message = response.data.message;
            this.snackbar = true;
            this.dialog = false;
            this.anexosForm.attachment_name = "";
            this.anexosForm.attachment = null;
            this.openButtons = true;
            this.$refs.form.resetValidation();
          })
          .catch((err) => {
            err;
            this.messageError = "Insira um arquivo PDF.";
            this.snackbar_error = true;
            this.dialog = false;
            var error = "";
            Object.values(this.$store.state.errorMessage).map((value) => {
              error = value;
            });
            this.displayError.message = error.toString();
            this.displayError.display = true;
            setTimeout(() => {
              this.displayError.display = false;
            }, 3000);
          })
          .finally(() => {
            this.loadTable();
          });
      }
    },

    loadTable() {
      axios.get("/attachments").then((response) => {
        this.arquivos = response.data.data;
        this.arquivos = this.arquivos.filter(
          (x) => x.donor_id == this.anexosForm.donor_id
        );
      });
    },

    deleteAttachment(item) {
      const attachmentId = item.id;
      axios.delete(`/attachments/${attachmentId}`).then((response) => {
        this.loading = true;
        this.message = response.data.message;
        this.snackbar = true;
        this.loadTable();
      });
    },

    createAttachments() {
      if (this.$refs.form.validate()) {
        this.anexosForm.donor_id = this.donorId;
        const attachments = this.anexosForm;
        axios
          .post(`/attachments`, attachments)
          .then((response) => {
            this.loadGridData();
            this.message = response.data.message;
            this.snackbar = true;
            this.dialog = false;
          })
          .catch((err) => {
            err;
            var error = "";
            Object.values(this.$store.state.errorMessage).map((value) => {
              error = value;
            });
            this.displayError.message = error.toString();
            this.displayError.display = true;
            setTimeout(() => {
              this.displayError.display = false;
            }, 3000);
          });
      }
    },

    redirect() {
      let id = this.resource.id ? this.resource.id : this.donor_id;
      this.changeDonorId(id);
      this.changeCaptationData({});
      this.$router.push("/cadastrar-captacao");
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  /* font-weight: bold; */
}

.d-flex {
  padding: 0 12px;
}

.space {
  width: 5px;
}

.space-personalized {
  padding: 4px;
}

.spacediferent {
  width: 7px;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #27ae60, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #ee106d, #e46987);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
